import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CareGap`;

const insertOutreach = async (outreachData) => {
  try {
    const response = await axios.post(`${API_URL}/outreach`, outreachData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error inserting outreach:", error?.response?.data || error);
    throw error;
  }
};

export default insertOutreach;
